/**
 * The name a RIC wears in the field.
 *
 * Operators do not refer to a unit by its Sigfox ID or its database id — they
 * refer to it by the label printed on the enclosure, RIC1030_0394, which is the
 * product prefix followed by the serial number padded to four digits. Anywhere a
 * screen names a device to someone who also handles it physically, this is the
 * name it should use.
 */
export const RIC_PREFIX = 'RIC1030'

/** Zero-padded to four digits, which is how the label reads on every unit. */
const SERIAL_DIGITS = 4

/**
 * `394` → `RIC1030_0394`. A serial that is not a plain number is passed through
 * as-is rather than mangled, and a missing one yields null so callers can fall
 * back to whatever other identifier they hold.
 */
export function formatRicLabel(serialNumber: string | number | null | undefined): string | null {
  if (serialNumber === null || serialNumber === undefined) return null
  const raw = String(serialNumber).trim()
  if (!raw) return null
  const serial = /^\d+$/.test(raw) ? raw.padStart(SERIAL_DIGITS, '0') : raw.toUpperCase()
  return `${RIC_PREFIX}_${serial}`
}
